import styled from 'styled-components';
import RichText from '../base/richText';
import theme from '../../constants/theme';
import Button from '../button-v2';
import media from '../../constants/media';
import RichTextTitle from '../base/richTextTitle';

export const Root = styled.div`
	margin-top: 100px;
`;

export const CardWrapper = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
	border-radius: 10px;
	margin: 10px;
	overflow: hidden;
	height: 100%;
`;

export const CardContent = styled.div`
	margin: 20px;
	padding: 0 1rem;
	width: 100%;
`;

export const RichTextTitleStyled = styled(RichTextTitle)`
	align-self: center;
	text-align: center;
	margin-bottom: 20px;

	${media.desktopSmall`
		margin-bottom: 32px;
	`}
`;

export const RichTextStyled = styled(RichText)`
	font-weight: ${theme.fonts.weight.medium};
	font-size: 16px;
	margin-top: 20px;
`;

export const StyledButton = styled(Button)`
	margin-top: 20px;
	text-align: center;

	span {
		white-space: normal;
	}
`;

export const FirstNameWrapper = styled.h4`
	font-size: 24px;
	font-family: ${theme.fonts.SharpSlab};
	font-weight: ${theme.fonts.weight.regular};
	letter-spacing: -0.04em;
	line-height: 1.2;
	color: ${theme.colorsV2.mainRed};
	overflow-wrap: break-word;
`;

export const LastNameWrapper = styled.h3`
	font-size: 32px;
	font-family: ${theme.fonts.SharpSlab};
	font-weight: ${theme.fonts.weight.semiBold};
	letter-spacing: -0.04em;
	line-height: 1.2;
	color: ${theme.colorsV2.mainRed};
	max-width: 100%;
	overflow-wrap: break-word;
`;

export const Image = styled.img`
	max-width: 100%;
	border-radius: 16px;

	max-height: 550px;

	${media.desktopSmall`
		max-height: 680px;
	`}
`;
